import { EventSourcePolyfill } from 'event-source-polyfill';
import UserService from './keycloak';
import { apiConfig } from './apiConfig';
import { AMLS_COMMON } from '../pages/constants/globalConstants';

const SSE_PATH = `${AMLS_COMMON}/notifications/events/stream`;

class NotificationStreamService {
  constructor({ onMessage, onError, moduleId }) {
    this.onMessage = onMessage;
    this.onError = onError;
    this.moduleId = moduleId;
    this.eventSource = null;
  }

  connect() {
    this.disconnect();

    const token = UserService.getToken();
    if (!token) return;

    let url = `${apiConfig.serviceApi}${SSE_PATH}`;
    if (this.moduleId) {
      url += `?sourceId=${encodeURIComponent(this.moduleId)}`;
    }

    this.eventSource = new EventSourcePolyfill(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'text/event-stream',
        'Cache-Control': 'no-cache'
      }
    });

    const originalDispatch = this.eventSource.dispatchEvent.bind(
      this.eventSource
    );
    this.eventSource.dispatchEvent = (event) => {
      if (event.type !== 'open' && event.type !== 'error' && event.data) {
        try {
          const data = JSON.parse(event.data);
          this.onMessage?.({ ...data, eventType: event.type });
        } catch (error) {
          console.warn('SSE parse error:', error);
        }
      }
      return originalDispatch(event);
    };

    this.eventSource.onerror = () => {
      this.disconnect();
      this.reconnectTimeout = setTimeout(() => this.connect(), 5000);
    };
  }

  disconnect() {
    clearTimeout(this.reconnectTimeout);
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }
}

export default NotificationStreamService;
